<template>
  <div class="login-wrapper wf-section">
    <div class="main-login-wrapper">
      <div class="left-wrapper">
        <a href="https://www.timeslate.com">
          <img
            src="@/assets/timeslot-images/timeslate-white.svg"
            loading="lazy"
            alt=""
            class="bookaslot"
          />
        </a>

        <!--        Imag.svg-->
        <img
          src="@/assets/timeslot-images/AuthImage.svg"
          loading="lazy"
          alt=""
          class="image-2"
        />
      </div>

      <div class="right-wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "TimeslotAuthLayout",
  methods: {
    // home() {
    //   RouterUtils.changeRouteTo(RouterUtils.routes.auth.LANDING_PAGE);
    // }
  }
};
</script>

<style scoped>
.bookaslot {
  cursor: pointer;
}
</style>
